import { createGetPropGetter } from '@/store/utils';

export default {
  highlightReports: createGetPropGetter('highlightReports', []),
  highlightReportsStats: createGetPropGetter('highlightReportsStats', {}),
  highlightReportsLoading: createGetPropGetter('highlightReportsLoading', false),
  highlightReportsListOptions: createGetPropGetter('highlightReportsListOptions', {}),
  highlightReportsListSort(state, { highlightReportsListOptions = {} }) {
    return highlightReportsListOptions.sort || {};
  },
};
